var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"height":"24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M21 1a2 2 0 0 1 2 2v18a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zM5 18H3v3h2zm12-5H7v8h10zm4 5h-2v3h2zM5 13H3v3h2zm16 0h-2v3h2zM5 8H3v3h2zm16 0h-2v3h2zm-4-5H7v8h10zm4 0h-2v3h2zM5 3H3v3h2z","fill-rule":"evenodd"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }